import React from "react";
export const Circle = () => (
  <svg viewBox="0 0 12 16">
    <circle cx="6" cy="8" fill="#192547" r="6" />
  </svg>
);
